import React from "react";
import PropTypes from "prop-types";
import { MDBContainer, MDBIcon } from "mdbreact";

const opcoes = [
	{
		id: "presencial",
		titulo: "Presencial e semi",
		subtitulo: "",
		descricao:
			"Escolha esta opção para ver as formas de ingresso nos cursos presenciais e semipresenciais.",
		icone: "university",
	},
	{
		id: "ead",
		titulo: "EAD",
		subtitulo: "",
		descricao:
			"Escolha esta opção para ver as formas de ingresso nos cursos de graduação EAD.",
		icone: "laptop",
	},
];

export default function SeletorModalidade({ modalidade, onSelect }) {
	return (
		<section
			className={`seletorModalidade ${
				modalidade ? "seletorModalidade--selecionado" : ""
			}`}
		>
			<MDBContainer>
				<div className="seletorModalidade-cabecalho">
					<span>COMECE POR AQUI</span>
					<h1>Como você quer estudar?</h1>
					<p>
						Escolha uma modalidade para ver as opções de Graduação e
						Extravestibular disponíveis para você.
					</p>
				</div>

				<div className="seletorModalidade-grid">
					{opcoes.map((opcao) => {
						const ativa = modalidade === opcao.id;

						return (
							<button
								type="button"
								key={opcao.id}
								className={`seletorModalidade-card ${
									ativa ? "seletorModalidade-card--ativo" : ""
								}`}
								onClick={() => onSelect(opcao.id)}
								aria-pressed={ativa}
							>
								<div className="seletorModalidade-icon">
									<MDBIcon icon={opcao.icone} />
								</div>

								<div className="seletorModalidade-cardTexto">
									<h2>{opcao.titulo}</h2>
									{opcao.subtitulo ? <strong>{opcao.subtitulo}</strong> : null}
									<p>{opcao.descricao}</p>
								</div>

								<div className="seletorModalidade-seta" aria-hidden="true">
									<MDBIcon icon="arrow-right" />
								</div>
							</button>
						);
					})}
				</div>
			</MDBContainer>
		</section>
	);
}

SeletorModalidade.propTypes = {
	modalidade: PropTypes.oneOf(["presencial", "ead"]),
	onSelect: PropTypes.func.isRequired,
};
